import React from 'react';
import {
  Box,
  Typography,
  TextField
} from '@mui/material';

const ReceiveDetailsStep = ({
  formData,
  handleChange
}) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, color: 'text.primary' }}>
        Step 4: Additional Information (Optional)
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', maxWidth: '800px' }}>
        <TextField
          label="Quantity"
          name="quantity"
          type="number"
          value={formData.quantity || 1}
          onChange={handleChange}
          placeholder="Number of items"
          sx={{ width: 120 }}
          size="small"
          inputProps={{
            min: 1,
            max: 100,
            // Allow clearing the field completely
            onKeyDown: (e) => {
              // Allow backspace to clear the field
              if (e.key === 'Backspace' && e.target.value === '1') {
                e.target.value = '';
              }
            }
          }}
        />
        {formData.quantity <= 1 && (
          <TextField
            label="Serial Number"
            name="serialNumber"
            value={formData.serialNumber || ''}
            onChange={handleChange}
            placeholder="Enter serial number if available"
            sx={{ flex: 1, minWidth: 250 }}
            size="small"
          />
        )}
      </Box>

      <Box sx={{ mt: 2, maxWidth: '800px' }}>
        <TextField 
          label="Notes" 
          name="notes"
          value={formData.notes || ''}
          onChange={handleChange}
          placeholder="Any additional notes about this equipment..."
          multiline
          rows={3}
          fullWidth
          size="small"
        />
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 2, fontStyle: 'italic' }}>
        💡 All fields in this step are optional. Add any additional information that might be useful for tracking this equipment.
      </Typography>
    </Box>
  );
};

export default ReceiveDetailsStep;